// SPDX-License-Identifier: Apache-2.0
"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var Trade_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Trade = exports.TradeOffer = exports.TradeFees = void 0;
const transaction_1 = require("./transaction");
const ledger_1 = require("../../ledger");
const assets = __importStar(require("../../ledger/assets"));
const typedjson_1 = require("../../export/typedjson");
const util_1 = require("../util");
const api_1 = require("./..");
const ethers_1 = require("ethers");
let TradeFees = class TradeFees {
    constructor(market, fee) {
        this.market = market;
        this.fee = fee;
    }
    packTagged(contract) {
        return new util_1.ABIEncoder(this.market, this.fee).pack("ErdstallTradeFees", contract);
    }
};
__decorate([
    typedjson_1.jsonMember(ledger_1.Address),
    __metadata("design:type", ledger_1.Address)
], TradeFees.prototype, "market", void 0);
__decorate([
    typedjson_1.jsonMember(() => assets.Assets),
    __metadata("design:type", assets.Assets)
], TradeFees.prototype, "fee", void 0);
TradeFees = __decorate([
    typedjson_1.jsonObject,
    __metadata("design:paramtypes", [ledger_1.Address, assets.Assets])
], TradeFees);
exports.TradeFees = TradeFees;
const tradeTypeName = "Trade";
let TradeOffer = class TradeOffer {
    constructor(owner, offer, request) {
        this.owner = owner;
        this.offer = offer;
        this.request = request;
        this.expiry = (1n << 64n) - 1n; // For now, never expire.
    }
    async sign(contract, signer) {
        const sig = await signer.signMessage(this.packTagged(contract).keccak256());
        this.sig = new api_1.Signature(sig);
        return this;
    }
    verify(contract) {
        if (!this.sig) {
            return false;
        }
        const rec = ethers_1.utils.verifyMessage(this.packTagged(contract).keccak256(), this.sig.toString());
        return rec === this.owner.toString();
    }
    packTagged(contract) {
        return new util_1.ABIEncoder()
            .encodeTagged(contract, this.owner, this.offer, ["uint64", this.expiry], this.request, this.fees ? this.fees : new Uint8Array())
            .pack("ErdstallTradeOffer", contract);
    }
};
__decorate([
    typedjson_1.jsonMember(ledger_1.Address),
    __metadata("design:type", ledger_1.Address)
], TradeOffer.prototype, "owner", void 0);
__decorate([
    typedjson_1.jsonMember(() => assets.Assets),
    __metadata("design:type", assets.Assets)
], TradeOffer.prototype, "offer", void 0);
__decorate([
    typedjson_1.jsonMember(() => assets.Assets),
    __metadata("design:type", assets.Assets)
], TradeOffer.prototype, "request", void 0);
__decorate([
    typedjson_1.jsonBigIntMember(),
    __metadata("design:type", typeof BigInt === "function" ? BigInt : Object)
], TradeOffer.prototype, "expiry", void 0);
__decorate([
    typedjson_1.jsonMember(TradeFees),
    __metadata("design:type", TradeFees)
], TradeOffer.prototype, "fees", void 0);
__decorate([
    typedjson_1.jsonMember(api_1.Signature),
    __metadata("design:type", api_1.Signature)
], TradeOffer.prototype, "sig", void 0);
TradeOffer = __decorate([
    typedjson_1.jsonObject,
    __metadata("design:paramtypes", [ledger_1.Address, assets.Assets, assets.Assets])
], TradeOffer);
exports.TradeOffer = TradeOffer;
let Trade = Trade_1 = class Trade extends transaction_1.Transaction {
    constructor(sender, nonce, offer) {
        super(sender, nonce);
        // Otherwise, throws "TypeError: Cannot read property 'sig' of undefined" in TypedJSON.parse.
        if (offer && !offer.sig)
            throw new Error("trade offer must be signed");
        this.offer = offer;
    }
    txType() {
        return Trade_1;
    }
    txTypeName() {
        return tradeTypeName;
    }
    encodeABI(e, contract) {
        e.encodeTagged(contract, this.offer.sig, this.offer);
        return "ErdstallTradeTX";
    }
};
__decorate([
    typedjson_1.jsonMember(TradeOffer),
    __metadata("design:type", TradeOffer)
], Trade.prototype, "offer", void 0);
Trade = Trade_1 = __decorate([
    typedjson_1.jsonObject,
    __metadata("design:paramtypes", [ledger_1.Address, typeof BigInt === "function" ? BigInt : Object, TradeOffer])
], Trade);
exports.Trade = Trade;
transaction_1.registerTransactionType(tradeTypeName, Trade);
//# sourceMappingURL=trade.js.map